<template>
  <modal
    class="editCategoryModal"
    name="editDealerCategoryModal"
    transition="pop-out"
    :width="650"
    :height="450"
    @opened="opened"
  >
    <div class="modal__header">
      <span class="mr-3"
        ><img src="@/assets/img/building (1).svg" width="50" height="60"
      /></span>
      <h4>{{ $t("text.editCategoryModal.title") }}</h4>
    </div>

    <div>
      <fieldset
        class="border p-3 form-group mt-3"
        style="margin: 0 auto; width: 85%"
      >
        <!-- <legend class="w-auto" style="color:#7D7885; font-size: 16px; padding: 10px">Branch Monthly Sales Target</legend> -->
        <div
          class="input__group__block mt-4"
          style="margin: 0 auto; width: 50%"
        >
          <label class="required">
            {{ $t("text.editCategoryModal.category") }}
          </label>
          <div class="input__block" ref="target_input_div">
            <input
              style="padding: 20px; width: 100%"
              type="text"
              :placeholder="$t('text.editCategoryModal.categoryPlaceholder')"
              v-model="categoryNameValue"
            />
          </div>

          <div ref="target_error"></div>
        </div>
        <div class="text-center py-3 mt-3">
          <button
            class="sales_target_btn text-center"
            @click="updateCategory($event)"
            :disabled="isButtonDisabled ? true : null"
            :style="[
              isButtonDisabled
                ? { cursor: 'not-allowed' }
                : { cursor: 'pointer' },
            ]"
          >
            {{ $t("text.editCategoryModal.title") }}<span></span>
          </button>
          <img
            src="@/assets/img/git_loader.gif"
            style="display: none"
            width="35px"
            class="ml-3 loader"
          />
        </div>
      </fieldset>
    </div>
  </modal>
</template>
<script>
const MODAL_WIDTH = 850;
import configObject from "@/config";

export default {
  name: "editDealerCategoryModal",
  props: ["id", "categoryName"],
  data() {
    return {
      categoryNameValue: "",
      modalWidth: MODAL_WIDTH,
      isButtonDisabled: false,
      showLoader: false,
      category: "",
    };
  },
  mounted() {},
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  methods: {
    closeCompanyModal() {
      this.$modal.hide("createTarget");
    },
    updateCategory($event) {
      if (!this.categoryNameValue) {
        this.$toast.open({
          message: this.$t("text.editCategoryModal.categoryMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }

      let data = {
        category: this.categoryNameValue,
        id: this.id,
      };
      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .put(
          `${configObject.apiBaseUrl}/Expenses/Category`,
          data,
          configObject.authConfig()
        )
        .then((response) => {
          this.$eventHub.$emit("refreshCategoryTable");
          this.isButtonDisabled = true;
          this.category = "";
          this.$toast.open({
            message:
              response.status === 200
                ? this.$t("text.editCategoryModal.successfullyEdited")
                : response.data.message,
            type: "success",
            duration: 4000,
          });
          $(".loader").hide();
          this.isButtonDisabled = false;
          this.$modal.hide("editDealerCategoryModal");
        })
        .catch(() => {
          this.$toast.open({
            message: this.$t("text.editCategoryModal.unsuccessfulEdit"),
            type: "error",
            duration: 5000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
    opened() {
      this.categoryNameValue = this.categoryName;
    },
  },
};
</script>
